import React, { lazy, Suspense } from 'react';

const LazyPreviousOrderDealerDisplays = lazy(() => import('./PreviousOrderDealerDisplays'));

const PreviousOrderDealerDisplays = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyPreviousOrderDealerDisplays {...props} />
  </Suspense>
);

export default PreviousOrderDealerDisplays;
